import { QUALIFICATION_CODE } from '../constants/qualification.constants';
import {
  allChildAgeGenderConditionCodes,
  toChildrenLegacyQualificationConditionCodes,
} from './child-age-gender-lib.adapter';

export function toChildrenLegacyQualificationCode(
  qualificationCode: number,
): number {
  return qualificationCode === QUALIFICATION_CODE.CHILD_AGE_GENDER
    ? QUALIFICATION_CODE.CHILDREN_LEGACY
    : qualificationCode;
}

export function toChildrenLegacyDependencyConditionCodes(
  conditionCodes: readonly number[],
  isExclusion: boolean,
): string[] {
  const listedConditionCodes = conditionCodes.map(String);
  if (!isExclusion) {
    return toChildrenLegacyQualificationConditionCodes(listedConditionCodes);
  }

  const listedConditionCodeSet = new Set(listedConditionCodes);
  return toChildrenLegacyQualificationConditionCodes(
    allChildAgeGenderConditionCodes().filter(
      (conditionCode) => !listedConditionCodeSet.has(conditionCode),
    ),
  );
}
